import { render, staticRenderFns } from "./tag-lv-new.vue?vue&type=template&id=de233e6a&scoped=true"
import script from "./tag-lv-new.vue?vue&type=script&lang=js"
export * from "./tag-lv-new.vue?vue&type=script&lang=js"
import style0 from "./tag-lv-new.vue?vue&type=style&index=0&id=de233e6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de233e6a",
  null
  
)

export default component.exports